// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"deebabd4","453":"c230d62e"}[chunkId] + ".chunk.js";
};